const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/sagas/snackbar.ts';
import { SagaIterator } from 'redux-saga';
import { put, takeEvery } from 'redux-saga/effects';
import { KeyValuePair } from '@cistec/common_web/defs/generalDefs';
import { addSnackbar } from 'App/actions/snackbar';
import textMap from './translations';
import { MessageDescriptor } from 'react-intl';
import { ColorSettings, Severity } from 'App/components/utils';
import { BOOK_APPOINTMENT, CANCEL_APPOINTMENT } from 'App/actions/appointment';
import { FINALIZE_ECHECKIN } from 'App/actions/eCheckinItems';

// Navigates to booking confirmation page after successful booking
// Loads the new termin as structured appointment
// Also handles patient clearing (for now...)

const getSnackbarFunction = (
    color: ColorSettings | Severity,
    message: MessageDescriptor,
    autoHideDuration?: number,
    canAddMultiple: boolean = true
) => {
    function* handlerFunction(result: KeyValuePair) {
        yield put(addSnackbar(color, message, autoHideDuration, canAddMultiple));
    }

    return handlerFunction;
};

export function* snackbarSaga(): SagaIterator {
    // session logout is implemented in -> packages/patapp_web/src/middleware/oauth2.ts

    // Appointment:
    yield takeEvery(BOOK_APPOINTMENT.success, getSnackbarFunction('success', textMap.appointmentBookingSuccess));
    yield takeEvery(CANCEL_APPOINTMENT.success, getSnackbarFunction('success', textMap.cancelAppointmentSuccess));

    // eCheckin:
    yield takeEvery(FINALIZE_ECHECKIN.success, getSnackbarFunction('success', textMap.finalizeEcheckinSuccess));
    // yield takeEvery(UPDATE_ECHECKIN.success, getSnackbarFunction('info', textMap.saveEcheckinSuccess, 3));
}
